// import  {aaa}  from 'https'
// import { get, post } from './https'
// // export function getListAPI(params){
// //   return http.get(`${resquest}/getList.json`,params)
// // }
// export const apiAddress = p => post('https://www.shangshebao.com/shangshebao/index.php/Home/Login/login', p)

// import http from './https.js'; // 导入接口域名列表
import {post} from './https'; // 导入http中创建的axios实例
// import qs from 'qs'; // 根据需求是否导入qs模块
const article = {

  // articleList () {
  //   return http.get(`${base.sq}/topics`);
  // },

  // articleDetail (id, params) {
  //   return http.get(`${base.sq}/topic/${id}`, {
  //     params: params
  //   });
  // },
  // // post提交
  login (params) {   //获取验证码
    // return post('https://www.shangshebao.com/shangshebao/index.php/Home/Login/sendCode', params);
    // return post('http://zpapi.yuexinduo.com/index/login/sendCode', params);
    return post('https://www.shangshebao.com/shangshebao/index.php/home/login/sendCode', params);

  },
  regist (params) {   //注册
                     // return post('https://www.shangshebao.com/shangshebao/index.php/Home/Login/sendCode', params);
    // return post('http://zpapi.yuexinduo.com/index/login/regist', params);
    return post('https://www.shangshebao.com/shangshebao/index.php/home/login/regist', params);
  },
  newPassWord (params) {   //设置密码
    // return post('https://www.shangshebao.com/shangshebao/index.php/Home/Login/sendCode', params);
    return post('https://www.shangshebao.com/shangshebao/index.php/home/login/setpaw', params);
  },
  codeLogin (params) {   //验证码登录
    // return post('https://www.shangshebao.com/shangshebao/index.php/Home/Login/login', params);
    // return post('http://zpapi.yuexinduo.com/index/login/login', params);
    return post('https://www.shangshebao.com/shangshebao/index.php/home/login/login', params);
    // https://www.shangshebao.com/shangshebao/index.php/home/login/login
  },
  changePassWord (params) {   //修改密码
    return post('https://www.shangshebao.com/shangshebao/index.php/home/login/setpaw', params);
  },
  // 其他接口…………
  obtainMy(params){ //获取用户信息

    // return post("http://123.56.127.39/test/public/index.php/index/resume/selectResumeInfo",params)
    return post("http://zpapi.yuexinduo.com/index/resume/selectResumeInfo",params)
    // return post("http://zpapi.shangshebao.com/index/resume/selectResumeInfo",params)
  },
  getMation(params){//获取个人优势
    // return post("http://zpapi.yuexinduo.com/index/resume/selectIntroduce",params)
    // return post("http://123.56.127.39/test/public/index.php/index/resume/selectIntroduce",params)
    return post("http://zpapi.yuexinduo.com/index/resume/selectIntroduce",params)
  },
  sendMation(params){//保存个人优势
    // return post("http://zpapi.yuexinduo.com/index/resume/selectIntroduce",params)
    // return post("http://123.56.127.39/test/public/index.php/index/resume/saveIntroduce",params)
    return post("http://zpapi.yuexinduo.com/index/resume/saveIntroduce",params)
  },
  getWork(params){//编辑获取工作经历
    // return post("http://zpapi.yuexinduo.com/index/resume/selectIntroduce",params)
    // return post("http://123.56.127.39/test/public/index.php/index/resume/selectWorkExperience",params)
    return post("http://zpapi.yuexinduo.com/index/resume/selectWorkExperience",params)
  },
  saveWork(params){//保存编辑工作经历
    // return post("http://zpapi.yuexinduo.com/index/resume/selectIntroduce",params)


    // return post("http://123.56.127.39/test/public/index.php/index/resume/saveWorkExperience",params)
    return post("http://zpapi.yuexinduo.com/index/resume/saveWorkExperience",params)
  },
  delWork(params){//删除编辑工作经历
    // return post("http://zpapi.yuexinduo.com/index/resume/selectIntroduce",params)


    // return post("http://123.56.127.39/test/public/index.php/index/resume/saveWorkExperience",params)
    return post("http://zpapi.yuexinduo.com/index/resume/deleteWorkExperience",params)
  },
  // getWork(params){//删除编辑工作经历
  //   // return post("http://zpapi.yuexinduo.com/index/resume/selectIntroduce",params)
  //   // return post("http://123.56.127.39/test/public/index.php/index/resume/saveWorkExperience",params)
  //   return post("http://zpapi.yuexinduo.com/index/resume/insertWorkExperience",params)
  // },
  addWork(params){//添加工作经历
    // return post("http://zpapi.yuexinduo.com/index/resume/selectIntroduce",params)
    // return post("http://123.56.127.39/test/public/index.php/index/resume/saveWorkExperience",params)
    return post("http://zpapi.yuexinduo.com/index/resume/insertWorkExperience",params)
  },
  addResume(params){//添加教育经历
    // return post("http://zpapi.yuexinduo.com/index/resume/selectIntroduce",params)
    // return post("http://123.56.127.39/test/public/index.php/index/resume/saveWorkExperience",params)
    return post("http://zpapi.yuexinduo.com/index/resume/insertEducation",params)
  },
  getResume(params){//获取编辑教育经历
    // return post("http://zpapi.yuexinduo.com/index/resume/selectIntroduce",params)
    // return post("http://123.56.127.39/test/public/index.php/index/resume/saveWorkExperience",params)
    return post("http://zpapi.yuexinduo.com/index/resume/selectEducation",params)
  },
  saveResume(params){//保存编辑教育经历
    // return post("http://zpapi.yuexinduo.com/index/resume/selectIntroduce",params)
    // return post("http://123.56.127.39/test/public/index.php/index/resume/saveWorkExperience",params)
    return post("http://zpapi.yuexinduo.com/index/resume/saveEducation",params)
  },
  delResume(params){//删除编辑教育经历
    // return post("http://zpapi.yuexinduo.com/index/resume/selectIntroduce",params)
    // return post("http://123.56.127.39/test/public/index.php/index/resume/saveWorkExperience",params)
    return post("http://zpapi.yuexinduo.com/index/resume/deleteEducation",params)
  },
  addProject(params){//添加项目经历
    // return post("http://zpapi.yuexinduo.com/index/resume/selectIntroduce",params)
    // return post("http://123.56.127.39/test/public/index.php/index/resume/saveWorkExperience",params)
    return post("http://zpapi.yuexinduo.com/index/resume/insertProjectExperience",params)
  },
  getEditProject(params){//获取编辑项目经历
    // return post("http://zpapi.yuexinduo.com/index/resume/selectIntroduce",params)
    // return post("http://123.56.127.39/test/public/index.php/index/resume/saveWorkExperience",params)
    return post("http://zpapi.yuexinduo.com/index/resume/selectProjectExperience",params)
  },
  saveEditProject(params){//保存编辑项目经历
    return post("http://zpapi.yuexinduo.com/index/resume/saveProjectExperience",params)
  },
  delEditProject(params){//删除编辑项目经历
    return post("http://zpapi.yuexinduo.com/index/resume/deleteProjectExperience",params)
  },
  addJobWanted(params){//添加职位期望
    return post("http://zpapi.yuexinduo.com/index/resume/insertJobIntention",params)
  },
  getJobWanted(params){//查询职位期望
    return post("http://zpapi.yuexinduo.com/index/resume/selectJobintention",params)
  },
  saveJobWanted(params){//保存职位期望
    return post("http://zpapi.yuexinduo.com/index/resume/saveJobIntention",params)
  },
  delJobWanted(params){//删除职位期望
    return post("http://zpapi.yuexinduo.com/index/resume/deleteJobIntention",params)
  },
  saveJobStatus(params){//更新求职状态
    return post("http://zpapi.yuexinduo.com/index/resume/saveJobStatus",params)
  },
  getPosition(params){//职位信息
    return post("http://zpapi.yuexinduo.com/index/job/jobInfo",params)
  },
  saveInfor(params){//修改个人信息
    return post("http://zpapi.yuexinduo.com/index/resume/saveInformation",params)
  },
  getDetailsPosition(params){//职位详情
    return post("http://zpapi.yuexinduo.com/index/job/jobDetail",params)
  },
  sendJob(params){//投递简历
    return post("http://zpapi.yuexinduo.com/index/job/insertUserSend",params)
  },
  //公司模块
  getComPosition(params){//公司查询职位
    return post("http://zpapi.yuexinduo.com/index/company/selectJobInfo",params)
  },
  getLeaderPosition(params){//leader
    return post("http://zpapi.yuexinduo.com/index/users/selectLeaderInfo",params)
  },
  sveLeaderPosition(params){//保存leader
    return post("http://zpapi.yuexinduo.com/index/users/saveUserInfo",params)
  },
  sveRemPosition(params){//保存编辑职位
    return post("http://zpapi.yuexinduo.com/index/company/saveJob",params)
  },
  addReleasePosition(params){//发布职位
    return post("http://zpapi.yuexinduo.com/index/company/insertJob",params)
  },
  addMyCompany(params){//给用户绑定添加公司
    return post("http://zpapi.yuexinduo.com/index/company/saveCompanyUser",params)
  },
  bindMyCompany(params){//绑定
    return post("http://zpapi.yuexinduo.com/index/company/selectCompanyName",params)
  },
  getComMy(params){//获取公司我的页面信息
    return post("http://zpapi.yuexinduo.com/index/users/selectUserInfo",params)
  },
  getComHomePage(params){//获取公司我的页面信息
    return post("http://zpapi.yuexinduo.com/index/company/selectcompanyInfo",params)
  },
  getcomMessage(params){//获取投递职位
    return post("http://zpapi.yuexinduo.com/index/company/selectCompanySend",params)
  },
  getMessage(params){//获取用户消息
    return post("http://zpapi.yuexinduo.com/index/job/selectUserSend",params)
  },
  saveJobState(params){//保存求职状态
    return post("http://zpapi.yuexinduo.com/index/company/saveJobState",params)
  },
  upload(params){//公司logo上传
    return post("http://zpapi.yuexinduo.com/index/company/uploadLogo",params)
  },
  WriteUpload(params){//写一写上传图片
    return post("http://zpapi.yuexinduo.com/index/news/upload",params)
  },
  write(params){//写一写
    return post("http://zpapi.yuexinduo.com/index/news/insertNews",params)
  },
  getWrite(params){//首页列表
    return post("http://zpapi.yuexinduo.com/index/news/newslist",params)
  },
  follow(params){//关注
    return post("http://zpapi.yuexinduo.com/index/news/saveFollow",params)
  },
  followLike(params){//点赞
    return post("http://zpapi.yuexinduo.com/index/news/saveLike",params)
  },
  comment(params){//点赞
    return post("http://zpapi.yuexinduo.com/index/news/insertComment",params)
  },
  retrievePwd(params){//找回密码
    return post("http://zpapi.yuexinduo.com/index/login/retrievePwd",params)
  },
  talentsDtails(params){//找人才
    return post("http://zpapi.yuexinduo.com/index/resume/selectResumeInfo",params)
  },
  invitationPost(params){//邀请投递
    return post("http://zpapi.yuexinduo.com/index/company/insertCompanySend",params)
  },
  getWord(params){//查询关键字
    return post("http://zpapi.yuexinduo.com/index/keyword/selectkeyword",params)
  },
  companySendList(params){//查看公司已邀请列表
    return post("http://zpapi.yuexinduo.com/index/Company/selectCompanySendList",params)
  },

  /*商城*/
  shopCarouselImg(params){//首页轮播图
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/shop/selectSlide",params)
  },
  shopList(params){//商城列表
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/shop/selectGoodsList",params)
  },
  shopclassification(params){//商城分类
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/shop/selectCategory",params)
  },
  GoodsDetail(params){//商品详情
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/shop/selectGoodsDetail",params)
  },
  insertCarts(params){//添加购物车
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/shop/insertCarts",params)
  },
  selectCarts(params){//购物车列表
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/shop/selectCarts",params)
  },
  selectRegion(params){//地区
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/user/selectRegion",params)
  },
  selectAddress(params){//查看收货地址
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/user/selectAddress",params)
  },
  insertAddress(params){//添加收货地址
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/user/insertAddress",params)
  },
  saveAddress(params){//添加收货地址
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/user/saveAddress",params)
  },

  saveDefaultAddress(params){//更新收货地址
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/user/saveDefaultAddress",params)
  },
  insertOrder(params){//生成订单
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/order/insertOrder",params)
  },
  selectOrderList(params){//全部订单
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/order/selectOrderList",params)
  },
  selectOrderDetail(params){//全部订单详情
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/order/selectOrderDetail",params)
  },
  deleteOrder(params){//全删除订单
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/order/deleteOrder",params)
  },
  deleteAddress(params){//删除地址
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/user/deleteAddress",params)
  },
  saveCarts(params){//更新购物车
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/shop/saveCarts",params)
  },
  Wxpay(params){//微信支付
    // return post("https://www.shangshebao.com/shangshebao/index.php/Home/Adapay/WxpubShop",params)
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/WxPay/Wxpay",params)
  },
  deleteCarts(params){//删除购物车
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/shop/deleteCarts",params)
    // return post("https://www.shangshebao.com/shangshebao/index.php/shop/WxPay/testWxpay",params)
  },
  selectExpress(params){//查询快递单号
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/Express/selectExpress",params)
    // return post("https://www.shangshebao.com/shangshebao/index.php/shop/WxPay/testWxpay",params)
  },
  selectCoupon(params){//优惠卷列表
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/user/selectCoupon",params)
    // return post("https://www.shangshebao.com/shangshebao/index.php/shop/WxPay/testWxpay",params)
  },
  selectGoodsInfo(params){//立即购买
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/shop/selectGoodsInfo",params)
    // return post("https://www.shangshebao.com/shangshebao/index.php/shop/WxPay/testWxpay",params)
  },
  selectUserCoupon(params){//获取用户优惠卷
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/user/selectUserCoupon",params)
    // return post("https://www.shangshebao.com/shangshebao/index.php/shop/WxPay/testWxpay",params)
  },
  selectGoodsCoupon(params){//获取商品优惠卷
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/shop/selectGoodsCoupon",params)
    // return post("https://www.shangshebao.com/shangshebao/index.php/shop/WxPay/testWxpay",params)
  },
  userCouponNumber(params){//优惠卷数量
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/user/userCouponNumber",params)
    // return post("https://www.shangshebao.com/shangshebao/index.php/shop/WxPay/testWxpay",params)
  },
  couponsOrder(params){//购买优惠卷
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/order/insertOrder",params)
    // return post("https://www.shangshebao.com/shangshebao/index.php/shop/WxPay/testWxpay",params)
  },
  selectCouponList(params){//购买优惠卷列表
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/shop/selectCouponList",params)
    // return post("https://www.shangshebao.com/shangshebao/index.php/shop/WxPay/testWxpay",params)
  },
  selectActivityGoodsList(params){//商品活动列表
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/shop/selectActivityGoodsList",params)
  },
  insertActivityCoupon(params){//50元优惠券
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/user/insertActivityCoupon",params)
  },
  riceShop(params){//粽子商品列表
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/shop/selectActivityGoods",params)
  },
  shareLink(params){//粽子商品列表
    return post("https://www.shangshebao.com/shangshebao/index.php/Home/Tuiguang/ceshi",params)
  },
  openqrcode(params){//二维码生成
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/order/openqrcode",params)
  },
  getuserinfo(params){//获取头像
    return post("https://www.shangshebao.com/shangshebao/index.php/Home/Getuserwxinfo/getuserinfo",params)
  },
  selectPintuanPeople(params){//判断拼团满没满
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/order/selectPintuanPeople",params)
  },
  shopQrCode(params){//普通分享
    return post("https://www.shangshebao.com/shangshebao/index.php/shop/order/shopQrCode",params)
  },
}

export default article



// WEBPACK FOOTER //
// ./src/utils/https/api.js